function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import CircularProgress from 'material-ui/CircularProgress';
import InfiniteScroll from 'react-infinite-scroller';
import { PRODUCTS_COUNT_IN_A_ROW } from 'swag-client-common/constants';
import { Button } from 'swag-client-common/components/ui/button';
import { EmptyList } from 'swag-client-common/components/partials/empty-list';
import { ListingProductCard } from '../product-card';
import classes from '../../product-listing.scss';
const styles = {
  productLoader: {
    bottom: '-65px',
    right: '45%',
    position: 'absolute'
  },
  noProductLoader: {
    top: '160px',
    margin: '-0 auto',
    display: 'block'
  }
};
const emptyItemsForCenterAligning = isFilterPopupOpen => Array(PRODUCTS_COUNT_IN_A_ROW).fill(null).map((el, index) => /*#__PURE__*/React.createElement("div", {
  key: `empty-${index}`,
  className: classnames(classes.emptyProductItem, {
    [classes.openedFilter]: isFilterPopupOpen
  })
}));
export class InfiniteProducts extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getItems", () => {
      const {
        products,
        isFilterPopupOpen,
        isLoggedIn
      } = this.props;
      if (!products) {
        return [];
      }
      return products.map(item => /*#__PURE__*/React.createElement(ListingProductCard, {
        isLoggedIn: isLoggedIn,
        isFilterPopupOpen: isFilterPopupOpen,
        item: item,
        key: item._id
      }));
    });
  }
  render() {
    const {
      shouldLoadMore,
      errored,
      page,
      isLoading,
      subcategories,
      products,
      getProducts,
      isFilterApplied,
      isFilterPopupOpen
    } = this.props;
    if (isLoading && products && products.length === 0) {
      return /*#__PURE__*/React.createElement(CircularProgress, {
        style: styles.noProductLoader
      });
    }
    const items = this.getItems();
    items.push(...emptyItemsForCenterAligning(isFilterPopupOpen));
    return /*#__PURE__*/React.createElement("div", {
      className: classes.infiniteScrollWrapper
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.spacer, {
        [classes.activeFilter]: isFilterPopupOpen
      })
    }), /*#__PURE__*/React.createElement(InfiniteScroll, {
      className: classnames(classes.itemsContainer, {
        [classes.itemsWithAppliedFilters]: isFilterApplied && subcategories,
        [classes.itemsWithOpenFilterDrawer]: isFilterPopupOpen
      }),
      loadMore: () => getProducts({
        page: page + 1
      }),
      hasMore: shouldLoadMore,
      threshold: 1000,
      loader: /*#__PURE__*/React.createElement(CircularProgress, {
        key: "infinite-products-progress",
        style: styles.productLoader
      })
    }, items.length !== PRODUCTS_COUNT_IN_A_ROW ? items : /*#__PURE__*/React.createElement(EmptyList, {
      wrapperClassName: classnames({
        [classes.emptyWithOpenedDrawer]: isFilterPopupOpen
      }),
      title: errored ? 'Something went wrong...' : 'No products match your selection',
      additionalContent: errored && /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        className: classes.retryCatalogButton,
        onClick: () => getProducts({
          page: page + 1
        })
      }, "Retry")
    })));
  }
}